export default "__VITE_ASSET__5ZdEnbTT__"